export const ROLE_TYPE: any = {
	USER: 'user',
	DYAD_ROLE: 'dyad_user',
	ADMIN_ROLE: 'admin',
	TEACHER_ROLE: 'teacher',
	ENROLLED_ROLE: 'enrolled',
};
